module.exports = __webpack_public_path__ + "static/img/6.b5d090b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/6.png
// module id = 5C3+
// module chunks = 0